import { usePaymentConfigApiV1 } from '../../../clients/quipli-service/payment-config/payment-config-api-v1';
import {
  PaymentMethodConfig,
  PaymentMethodRequest,
  PaymentMethodStatus,
  PaymentMethodConfigType,
} from '../../../clients/quipli-service/payment-config/payment-config';
import { useState } from 'react';
import { Modal } from '../../../components/modal/modal';
import { Button } from '../../../components/form/button';
import { Field } from '../../../components/field/field';

export const PaymentMethodModal = ({
  isOpen,
  close,
  paymentMethod,
}: {
  isOpen: boolean;
  close: () => void;
  paymentMethod?: PaymentMethodConfig;
}) => {
  const { createPaymentMethod, updatePaymentMethod } = usePaymentConfigApiV1();

  const [paymentMethodRequest, setPaymentMethodRequest] = useState<PaymentMethodRequest>({
    status: PaymentMethodStatus.Active,
    type: PaymentMethodConfigType.Custom,
    ...paymentMethod,
  });

  async function create() {
    if (paymentMethodRequest) {
      await createPaymentMethod(paymentMethodRequest);
      close();
    }
    throw new Error('Payment method is not defined');
  }

  async function update() {
    if (paymentMethod && paymentMethodRequest) {
      await updatePaymentMethod({ ...paymentMethod, ...paymentMethodRequest });
      close();
    }
    throw new Error('Payment method is not defined');
  }

  return (
    <Modal
      isOpen={isOpen}
      close={close}
      title={paymentMethod ? `Edit ${paymentMethod.displayName}` : 'Create a new payment method'}
    >
      <div>
        <Field
          type={'text'}
          value={paymentMethodRequest?.displayName}
          onChange={(e) =>
            setPaymentMethodRequest((prev) => {
              return { ...prev, displayName: e, name: e };
            })
          }
          isRequired={true}
          label={'Name'}
        />
        <Field
          type={'text'}
          value={paymentMethodRequest?.description}
          onChange={(e) =>
            setPaymentMethodRequest((prev) => {
              return { ...prev, description: e };
            })
          }
          isRequired={false}
          label={'Description'}
        />
      </div>
      <Button
        title={paymentMethod ? 'Update' : 'Create'}
        onClick={() => {
          paymentMethod ? update() : create();
        }}
        disabled={!paymentMethodRequest.displayName}
        className="button button-yellow"
      >
        {paymentMethod ? 'Update' : 'Create'}
      </Button>
    </Modal>
  );
};
